module.exports = "<!--<div class=\"panel\">-->\n\t<!--<div class=\"panel-heading\">-->\n    <!--<div id=\"header\" class=\"well well-lg\">-->\n        <!--<h1>Attendance</h1>-->\n    <!--</div>-->\n\t<!--</div>-->\n<!--</div>-->\n<!--<div class='container'>-->\n      <router-outlet></router-outlet>\n<!--</div>-->\n"


//////////////////
// WEBPACK FOOTER
// /home/hihoo/ibilling/attendence/public/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = 1